/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from '../../ComponentLogger';
import AnimationInstanceBase from './AnimationInstanceBase';

export default class CocosAnimationInstance extends AnimationInstanceBase<cc.Animation>
{
    public static readonly FinishedEvent: string = 'finished';

    private _lastAnimationState: cc.AnimationState = null;

    public Play(): Promise<any>
    {
        return new Promise<any>((resolve, reject) =>
            {
                try
                {
                    this._lastAnimationState = this.animation.play(this.options.AnimationName);
                    this._lastAnimationState.speed = this.options.Speed * this.dtMod;

                    const event: string = this.options.Loop
                        ? AnimationInstanceBase.StoppedEvent
                        : CocosAnimationInstance.FinishedEvent;
                    this.animation.once(event, () => resolve(true));
                }
                catch (error)
                {
                    reject(error);
                }
            });
    }

    public Stop(): CocosAnimationInstance
    {
        this.animation.setCurrentTime(0);

        // Try to refetch state..
        if (!this._lastAnimationState)
        {
            this._lastAnimationState = this.animation.getAnimationState(this.animation.currentClip.name);
        }

        // If there stop it.
        if (this._lastAnimationState)
        {
            this._lastAnimationState.stop();
        }
        else
        {
            CLog.warn('Could not stop, no valid animation state.', LogTypes.Effect);
        }

        // Set Default
        if (this.hasDefaultAnimation())
        {
            this.animation.play(this.options.DefaultAnimation);
        }

        this.emitStopped();
        return this;
    }
}
